import {
  CommonActionTypes,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  TOGGLE_APP_DRAWER,
} from '../../types/actions/Common.action';

export const fetchStart = (): CommonActionTypes => ({type: FETCH_START});

export const fetchSuccess = (): CommonActionTypes => ({type: FETCH_SUCCESS});

export const fetchError = (error: string): CommonActionTypes => ({
  type: FETCH_ERROR,
  error,
});

export const showMessage = (message: string): CommonActionTypes => ({
  type: SHOW_MESSAGE,
  message,
});

export const onToggleAppDrawer = (): CommonActionTypes => ({
  type: TOGGLE_APP_DRAWER,
});

export const hideMessage = (): CommonActionTypes => ({type: HIDE_MESSAGE});

/**
 * Extrait un message affichable d'une erreur axios.
 * Le 412 est le cas « ressource déjà verrouillée par quelqu'un d'autre » : l'API y met
 * un message explicite (avec le nom du détenteur), qu'on préfère au libellé générique.
 */
export const messageErreur = (error: any): string => {
  const message =
    error?.response?.data?.message ??
    error?.response?.data?.error ??
    error?.message;

  if (error?.response?.status === 412) {
    return (
      message ??
      'Ce dossier est actuellement verrouillé par un autre utilisateur.'
    );
  }

  return message ?? 'Erreur inconnue';
};
